import NotificationItem from "../notification-item/notification-item";
import TaskNotificationsList from "../task-notifications-list/task-notifications-list";
import {fullList} from "../index";
import {TaskType} from "../types";

export type NotificationType = {
  name: string;
  date: string;
  project: {
    id: number;
    name: string;
  };
  view: TaskNotificationsList;
  notifications: Map<number, any>;
}

class NotificationsState {
  private state: Map<number, NotificationType> = new Map();
  private length = 0;

  * values(): Generator<[number | undefined, NotificationType | undefined]> {
    for (const [key, value] of this.state) {
      yield [key, value];
    }

    yield [undefined, undefined];
  }

  [Symbol.iterator]() {
    return this.values();
  }

  constructor() {
    this.removeAllNotifications = this.removeAllNotifications.bind(this);
  }

  setInitialState(tasks: TaskType[]) {
    tasks.forEach(({id, name, date, notifications, projectId, projectName}) => {
      if (!this.state.has(id)) {
        this.state.set(id, {
          name,
          date,
          project: {
            id: projectId,
            name: projectName,
          },
          view: new TaskNotificationsList({
            name,
            id,
            projectName,
            counts: notifications.length,
          }, fullList.getSubListElement(date)),
          notifications: new Map(),
        });
      } else {
        if (this.state.has(id)) {
          if (this.state.get(id)!.date !== date) {
            this.state.get(id)!.date = date;
            this.state.get(id)!.view.setParent(fullList.getSubListElement(date));
          }
        }
      }

      notifications.forEach((notification) => {
        this.state.get(id)!
          .notifications
          .set(notification.id,
            {
              ...notification,
              view: new NotificationItem(
                {
                  id: notification.id,
                  projectId,
                  isNew: true,
                }),
            });
      });

      this.length = this.length + notifications.length;
    });
  }

  getState() {
    return this.state;
  }

  getTaskNotificationCount(taskId) {
    return this.state.get(taskId)!.notifications.size;
  }

  getLength() {
    return this.length;
  }

  decreaseLength(length: number) {
    this.length -= length;
  }

  removeNotification(taskId, notificationId) {
    this.state.get(taskId)!
      .notifications
      .delete(notificationId);

    if (this.state.get(taskId)!.notifications.size === 0) {
      this.state.get(taskId)!
        .view
        .removeElement();
      this.state.delete(taskId);
    }
  }

  removeAllNotifications() {
    this.state.clear();
    this.length = 0;
  }
}

export default NotificationsState;
